<div class="amates-app-component bg-121212 overflow-hidden">
  <router-outlet></router-outlet>
</div>
